import { useEffect } from 'react';
import ResearchDataGrid from '@components/DataGrid/Dispatch/ResearchGrid';
import useCurrentTerminal from '@hooks/useCurrentTerminal';
import usePageTitle from '@hooks/usePageTitle';
import ResearchForm from './ResearchForm';

import styles from './Research.module.css';

/**
 * Routed component for /{terminal}/Research
 */
export default function Page() {
  const { number: terminalNumber } = useCurrentTerminal();
  const { addPageTitle } = usePageTitle();

  useEffect(() => {
    addPageTitle('Research');
  }, [addPageTitle]);

  return (
    <div
      className={styles.container}
      key={`${terminalNumber}-research`}>
      <ResearchForm />
      <div className={styles['grid-container']}>
        <ResearchDataGrid />
      </div>
    </div>
  );
}
